<template>
    <div id="hero" class="form-container home-step" :ref="stepName" style="position:relative">
        <h4 class="purple-text">Offre réservée aux nouveaux membres</h4>
        <div v-if="is_blackfriday === 'true'" class="trust-wrapper">
            <img src="/images/fr_new_home/people.png" alt="" width="128" height="52">
            <p style="margin: 0;"><strong>+ 275 000</strong> personnes <br> nous font confiance</p>
        </div>
        <h2>Découvrez Testachats<br>pendant 2 mois <br> <span class="orange-text">pour 2&nbsp;€</span></h2>
        <p>Et choisissez votre cadeau de bienvenue parmi des dizaines de marques</p>
        <b-button class="button is-primary next-button" @click="nextStep()">Demandez votre pack  </b-button>



        <b-loading :is-full-page="false" v-model="loading"></b-loading>
    </div>
</template>

<script>
import {gsap} from 'gsap';
import mixin from "../../../travel_step_mixin";
import image_mixin from "../../../../../../views/_commons/fr/mixins/image_mixin";
import ScrollLink from "../../../../../../views/_commons/fr/ScrollLink";
import animation_mixin from "../../../animation_engine_mixin";

export default {
    mixins: [mixin,image_mixin],
    components:{ScrollLink},
    mounted(){

    }
}
</script>
